"use client"

import { useState } from "react"
import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar"
import { Badge } from "../../ui/badge"
import { Button } from "../../ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card"
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover"
import { Mail, User } from "lucide-react"
import { useEffect } from "react"
import { useRelativeTime, useCRUDController } from "../../ui/ot"
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';

const MessageInboxMenu = ({
    keyPrefix = "library.message_notification",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    // Sample messages data
    const messages = [
    ]
    // Count unread messages
    const unreadCount = messages.filter((msg) => !msg.read).length
    const LogoSelfController = useCRUDController({
        apiRoute: "/system/user/token/log_self"
    })
    useEffect(() => {
        LogoSelfController.getData({
            cur_page: 1,
            size: 20
        })
    }, [])
    return (
        <div className="flex items-center justify-end">

            {/* This would typically be part of a navbar */}
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button size="icon" className="relative">
                        <Mail className="h-5 w-5 " />
                        {unreadCount > 0 && (
                            <Badge
                                variant="destructive"
                                className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
                            >
                                {unreadCount}
                            </Badge>
                        )}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-80 p-0 md:w-96" align="end">
                    <Card className="border-0 shadow-none">
                        <CardHeader className="py-3 px-4 border-b">
                            <CardTitle className="text-base">{t('inbox')}</CardTitle>
                        </CardHeader>
                        <CardContent className="p-0 max-h-[400px] overflow-auto">
                            {(LogoSelfController?.ResponseData || []).length > 0 ? (
                                <div className="divide-y">
                                    {LogoSelfController?.ResponseData?.map((message) => {
                                        return (<div
                                            key={message?.id}
                                            className={`p-3 hover:bg-muted/50 transition-colors cursor-pointer ${!message?.read ? "bg-muted/30" : ""
                                                }`}
                                        >
                                            <div className="flex items-start gap-3">
                                                <Avatar className="h-8 w-8">

                                                    <AvatarFallback> <User className="h-4 w-4" /></AvatarFallback>
                                                </Avatar>
                                                <div className="flex-1 space-y-1 overflow-hidden">
                                                    <div className="flex items-center justify-between">
                                                        <div className="font-medium text-sm flex items-center gap-2">
                                                            {message?.account}
                                                            {!message?.read && (
                                                                <Badge variant="default" className="ml-1 text-xs py-0 h-5">
                                                                    {t('new')}
                                                                </Badge>
                                                            )}
                                                        </div>
                                                        <div className="text-xs text-muted-foreground"><RelativeDateAndTime
                                                            time={message?.date_and_time}
                                                        /></div>
                                                    </div>
                                                    <div className="font-medium text-xs">{message?.title}</div>
                                                    <p className="text-xs text-muted-foreground truncate">{message?.content}</p>
                                                </div>
                                            </div>
                                        </div>)
                                    })}
                                </div>
                            ) : (
                                <div className="py-6 text-center text-muted-foreground">  {t('no_new_messages')}</div>
                            )}
                        </CardContent>
                        <div className="p-2 border-t text-center">
                            <Button variant="ghost" size="sm" className="w-full text-sm" onClick={() => {
                                navigate('/library/message_notification')
                            }}>
                                {t('view_all_messages')}
                            </Button>
                        </div>
                    </Card>
                </PopoverContent>
            </Popover>
        </div>
    )
}
const RelativeDateAndTime = ({ time }) => {
    const time1 = useRelativeTime(time, "zh"); // 昨天
    return <>
        {time1}
    </>
}

export default MessageInboxMenu